import { AppstoreAddOutlined, PlusOutlined } from '@ant-design/icons';
import { arrayMove } from '@dnd-kit/sortable';
import { Button, Form } from 'antd';
import { useContext, useState } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { EmptyState } from 'app/components/pages/Extranet/commons/EmptyState/EmptyState';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import type {
  PackResponse,
  PackRoomResponse,
} from 'app/typings/core/admin/packs/pack';

import '../ExperiencesAndRooms.scss';

import { AddRoomsModal } from './AddRoomsModal/AddRoomsModal';
import { SortableRoomsList } from './SortableRoomsList';

export const PackRooms = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance<
    Partial<PackResponse> & {
      packRooms: PackRoomResponse[];
      isDaytime: boolean;
    }
  >();
  const formValues = Form.useWatch([], form);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);

  const onSortEnd = ({
    oldIndex,
    newIndex,
  }: {
    oldIndex: number;
    newIndex: number;
  }) => {
    const current: PackRoomResponse[] = form.getFieldValue('packRooms') || [];

    const reordered = arrayMove(current, oldIndex, newIndex).map((e, idx) => ({
      ...e,
      priority: idx,
    }));

    form.setFieldsValue({ packRooms: reordered });
    form.validateFields();
  };

  return (
    <div className="er-card er-card-rooms">
      <div className="er-header-row">
        <div className="er-header-title">Rooms</div>
        <Button
          disabled={!isEditMode}
          icon={<PlusOutlined />}
          onClick={openModal}
        >
          Add room
        </Button>
      </div>

      <FormLineLayout>
        <Form.Item name="packRooms" noStyle />
      </FormLineLayout>

      {formValues?.packRooms.length > 0 ? (
        <SortableRoomsList
          rooms={[...formValues?.packRooms].sort(
            (a, b) => (a.priority ?? 0) - (b.priority ?? 0)
          )}
          isEditMode={isEditMode}
          onSortEnd={onSortEnd}
        />
      ) : (
        <EmptyState
          title="No rooms"
          description="Associate a room to this package"
          icon={<AppstoreAddOutlined />}
        />
      )}

      <AddRoomsModal visible={isModalVisible} onClose={closeModal} />
    </div>
  );
};
